import React, { Component } from "react";
import { Row, Col, Button, Modal, Image, Spinner } from "react-bootstrap";
import InputField from "../../components/InputFieldComponent";
import { SettingHeader } from "./../TutorSetting/SpecificSettingComp";
import { debounce } from "lodash";
import { updateTutorSettings, getSetting } from "../../apis/tutors";
import { connect } from "react-redux";
import { TutorSettingAction } from "./../../redux/actions";
import DropdownWithSearch from "./../../components/DropdownWithSearch/index";
import { countyArray } from "./../../components/JsonData";
import { InfoModal } from "./../../components/modals/InfoModal";

class PaymentDetail extends Component {
  constructor() {
    super();
    this.state = {
      swithToogle: false,
      accountHolderName: "",
      bankAccountShortCode: "",
      accountNumber: "",
      bankAddressRaw: "",
      bankAddress: {
        street: "",
        town: "",
        country: "",
        postCode: "",
      },
      bankAddressRaw: "",
      postCodeArray: [],
      searchmode: false,
      postcodeLoader: false,
      accountHolderNameRequired: false,
      bankAccountShortCodeRequired: false,
      accountNumberRequired: false,
    };
  }

  componentDidMount = () => {
    let {
      bankAddress,
      accountHolderName,
      bankAccountShortCode,
      accountNumber,
    } = this.state;
    const { tutorSettingData } = this.props;
    let banking = tutorSettingData?.tutorDetails?.banking;
    bankAddress = banking?.bankAddress;
    accountHolderName = banking?.accountHolderName;
    bankAccountShortCode = banking?.bankAccountShortCode;
    accountNumber = banking?.accountNumber;
    this.setState({
      bankAddress,
      accountHolderName,
      bankAccountShortCode,
      accountNumber,
    });
  };

  componentDidUpdate = (prevProps) => {
    let {
      bankAddress,
      accountHolderName,
      bankAccountShortCode,
      accountNumber,
    } = this.state;
    const { tutorSettingData } = this.props;
    if (
      JSON.stringify(prevProps.tutorSettingData) !==
      JSON.stringify(tutorSettingData)
    ) {
      let banking = tutorSettingData?.tutorDetails?.banking;
      bankAddress = banking?.bankAddress;
      accountHolderName = banking?.accountHolderName;
      bankAccountShortCode = banking?.bankAccountShortCode;
      accountNumber = banking?.accountNumber;
      this.setState({
        bankAddress,
        accountHolderName,
        bankAccountShortCode,
        accountNumber,
      });
    }
  };
  getTextstate = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      [`${e.target.name}Required`]: true,
    });
  };
  getTextOfBilling = (e) => {
    let { bankAddress } = this.state;
    bankAddress = bankAddress ? bankAddress : {};
    bankAddress[e.target.name] = e.target.value;
    this.setState({
      bankAddress,
    });
  };

  getPostCode = debounce((text) => {
    this.setState({
      postcodeLoader: true,
    });
    let isInputFieldEmptyRE = /^\s*$/;
    if (!isInputFieldEmptyRE.test(text)) {
      fetch(`https://api.postcodes.io/postcodes/${text}/autocomplete`)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          if (response.status === 200) {
            this.setState({
              postCodeArray: response.result,
              searchmode: true,
              postcodeLoader: false,
            });
          }
        })
        .catch((error) => {
          this.setState({
            postcodeLoader: false,
          });
        });
    } else {
      this.setState({
        searchmode: false,
        postcodeLoader: false,
        postCodeArray: [],
      });
    }
  }, 200);
  updatePaymentDetail = () => {
    let user = JSON.parse(localStorage.getItem("userDetail"));
    let user_id = user.user.userId;
    const {
      swithToogle,
      bankAddress,
      accountHolderName,
      bankAccountShortCode,
      accountNumber,
    } = this.state;
    let bankAddressRaw = `${bankAddress.street} ${bankAddress.town} ${bankAddress.county} ${bankAddress.postCode}`;
    let updateSettingParam = {
      updateSetting: {
        accountHolderName,
        bankAddressRaw,
        bankAddress,
        bankAccountShortCode,
        accountNumber,
      },
    };
    updateTutorSettings(updateSettingParam)
      .then((res) => {
        if(res.status === 200){
          InfoModal("Updates", "Successfully Update");
          getSetting({ user_id })
          .then((res) => {          
            this.setState({
              loader: false,
            });
          })
          .catch((err) => console.log(err));
        }
        else{
          InfoModal("Error", "Something went wrong");
          this.setState({
            loader: false,
          });
        }
      
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loader: false,
        });
      });
  };

  matchReAccount = (e) => {
    const { accountNumber } = this.state;
    if (e.target.value) {
      this.setState({
        reAccountNumber: e.target.value,
        matchMessage:
          accountNumber === e.target.value
            ? ""
            : "Account number does not match",
      });
    } else {
      this.setState({
        reAccountNumber: "",
        matchMessage: "",
      });
    }
  };
  onSelect = (value, name) => {
    let { bankAddress } = this.state;
    bankAddress = bankAddress ? bankAddress : {};
    bankAddress[name] = value;
    this.setState({ bankAddress });
  };
  render() {
    let {
      swithToogle,
      bankAddress,
      postCodeArray,
      searchmode,
      postcodeLoader,
      accountHolderName,
      bankAccountShortCode,
      accountNumber,
      reAccountNumber,
      matchMessage,
      accountHolderNameRequired,
      bankAccountShortCodeRequired,
      accountNumberRequired,
    } = this.state;
    const { isModalPayment, onHide } = this.props;
    console.log(bankAddress,bankAddress)
    return (
      <div className="container">
        <Row className="flex-center-center ">
          <Col lg={8} md={8} sm={12} xs={12}>
            <SettingHeader
              settingName={"Earnings details"}
              headerTitle={"Earnings details"}
              headerDesciption="This need to be a UK bank account with a UK billing address. You can change these details at any point, by entering your new details in the fields below"
              goToAccount={() => this.props.history.push("/tutor-setting")}
            />
            <InputField
              InputHeadTitle={"Account name"}
              type="text"
              placeholder="Account holder name"
              value={accountHolderName}
              name="accountHolderName"
              onChange={this.getTextstate}
              style={{
                height: "56px",
                fontSize: "16px",
                color: "#0f0f0f",
                headTitle: {
                  fontWeight: "600",
                  fontSize: "18px",
                  color: "#0f0f0f",
                  marginBottom: "10px",
                  fontFamily: "OpenSans, Arial, sans-serif",
                },
                borderGroup:
                  !accountHolderName && accountHolderNameRequired
                    ? "1px solid #fa4a4a"
                    : null,
                backgroundColor:
                  !accountHolderName && accountHolderNameRequired
                    ? "#fff1f1"
                    : null,
              }}
              required={accountHolderNameRequired}
            />
            {!accountHolderName && accountHolderNameRequired ? (
              <div
                style={{
                  color: "#fa4a4a",
                  fontSize: "14px",
                  marginBottom: "10px",
                }}
                className="flex-start-center"
              >
                <Image
                  src={require("./../../assets/icons/info.png")}
                  style={{ marginRight: "10px" }}
                />
                Account name required
              </div>
            ) : (
              ""
            )}
            <Row style={{ margin: "0px" }}>
              <Col lg={6} md={6} sm={12} xs={12} style={{ paddingLeft: "0px" }}>
                <InputField
                  InputHeadTitle={"Bank account sort code "}
                  value={bankAccountShortCode}
                  name="bankAccountShortCode"
                  placeholder="e.g 123456"
                  onChange={this.getTextstate}
                  style={{
                    height: "56px",
                    fontSize: "16px",
                    color: "#0f0f0f",
                    headTitle: {
                      fontWeight: "600",
                      fontSize: "18px",
                      color: "#0f0f0f",
                      marginBottom: "10px",
                      fontFamily: "OpenSans, Arial, sans-serif",
                    },
                    borderGroup:
                      !bankAccountShortCode && bankAccountShortCodeRequired
                        ? "1px solid #fa4a4a"
                        : null,
                    backgroundColor:
                      !bankAccountShortCode && bankAccountShortCodeRequired
                        ? "#fff1f1"
                        : null,
                  }}
                  required={bankAccountShortCodeRequired}
                />
                {!bankAccountShortCode && bankAccountShortCodeRequired ? (
                  <div
                    style={{
                      color: "#fa4a4a",
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                    className="flex-start-center"
                  >
                    <Image
                      src={require("./../../assets/icons/info.png")}
                      style={{ marginRight: "10px" }}
                    />
                    Account sort code required
                  </div>
                ) : (
                  ""
                )}
              </Col>
              <Col
                lg={6}
                md={6}
                sm={12}
                xs={12}
                style={{ paddingRight: "0px" }}
              >
                <InputField
                  InputHeadTitle={"Account number "}
                  type="number"
                  name="accountNumber"
                  value={accountNumber}
                  placeholder="e.g 123456"
                  onChange={this.getTextstate}
                  style={{
                    height: "56px",
                    fontSize: "16px",
                    color: "#0f0f0f",
                    headTitle: {
                      fontWeight: "600",
                      fontSize: "18px",
                      color: "#0f0f0f",
                      marginBottom: "10px",
                      fontFamily: "OpenSans, Arial, sans-serif",
                    },
                    borderGroup:
                      !accountNumber && accountNumberRequired
                        ? "1px solid #fa4a4a"
                        : null,
                    backgroundColor:
                      !accountNumber && accountNumberRequired
                        ? "#fff1f1"
                        : null,
                  }}
                  required={accountNumberRequired}
                />
                {!accountNumber && accountNumberRequired ? (
                  <div
                    style={{
                      color: "#fa4a4a",
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                    className="flex-start-center"
                  >
                    <Image
                      src={require("./../../assets/icons/info.png")}
                      style={{ marginRight: "10px" }}
                    />
                    Account number required
                  </div>
                ) : (
                  ""
                )}
              </Col>
              <Col lg={12} md={12} sm={12} xs={12} style={{ padding: "0px" }}>
                <InputField
                  InputHeadTitle={"Confirm account number"}
                  type="number"
                  name="accountNumber"
                  value={reAccountNumber}
                  placeholder="e.g 123456"
                  onChange={(e) => this.matchReAccount(e)}
                  style={{
                    height: "56px",
                    fontSize: "16px",
                    color: "#0f0f0f",
                    headTitle: {
                      fontWeight: "600",
                      fontSize: "18px",
                      color: "#0f0f0f",
                      marginBottom: "10px",
                      fontFamily: "OpenSans, Arial, sans-serif",
                    },
                    // borderGroup:
                    //   !lastName && lastNameReq ? "1px solid #fa4a4a" : null,
                    // backgroundColor: !lastName && lastNameReq ? "#fff1f1" : null,
                  }}
                />
                {matchMessage ? (
                  <div
                    style={{
                      color: "#fa4a4a",
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                    className="flex-start-center"
                  >
                    <Image
                      src={require("./../../assets/icons/info.png")}
                      style={{ marginRight: "10px" }}
                    />
                    {matchMessage}
                  </div>
                ) : (
                  ""
                )}
              </Col>
            </Row>
            <hr />

            <InputField
              InputHeadTitle={"Billing address"}
              type="text"
              onChange={this.getTextOfBilling}
              value={bankAddress?.street ? bankAddress?.street : ""}
              placeholder="Street"
              name="street"
              style={{
                height: "56px",
                fontSize: "16px",
                color: "#0f0f0f",
                headTitle: {
                  fontWeight: "600",
                  fontSize: "24px",
                  color: "#0f0f0f",
                  marginBottom: "10px",
                  fontFamily: "OpenSans, Arial, sans-serif",
                },
                // borderGroup:
                //   !lastName && lastNameReq ? "1px solid #fa4a4a" : null,
                // backgroundColor: !lastName && lastNameReq ? "#fff1f1" : null,
              }}
            />
            <InputField
              type="text"
              onChange={this.getTextOfBilling}
              value={bankAddress?.town ? bankAddress?.town : ""}
              placeholder="Town"
              name="town"
              style={{
                height: "56px",
                fontSize: "16px",
                color: "#0f0f0f",
                headTitle: {
                  fontWeight: "600",
                  fontSize: "18px",
                  color: "#0f0f0f",
                  marginBottom: "10px",
                  fontFamily: "OpenSans, Arial, sans-serif",
                },
                // borderGroup:
                //   !lastName && lastNameReq ? "1px solid #fa4a4a" : null,
                // backgroundColor: !lastName && lastNameReq ? "#fff1f1" : null,
              }}
            />
            <Row style={{ margin: "0px" }}>
              <Col lg={6} md={6} sm={12} xs={12} style={{ paddingLeft: "0px" }}>
                {/* <InputField
                  type="text"
                  onChange={this.getTextOfBilling}
                  value={bankAddress?.county ? bankAddress?.county : ""}
                  placeholder="County"
                  name="county"
                  style={{
                    height: "56px",
                    fontSize: "16px",
                    color: "#0f0f0f",
                    headTitle: {
                      fontWeight: "600",
                      fontSize: "18px",
                      color: "#0f0f0f",
                      marginBottom: "10px",
                      fontFamily: "OpenSans, Arial, sans-serif",
                    },
                    // borderGroup:
                    //   !lastName && lastNameReq ? "1px solid #fa4a4a" : null,
                    // backgroundColor: !lastName && lastNameReq ? "#fff1f1" : null,
                  }}
                /> */}
                <DropdownWithSearch
                  // dropdownTitle="County"
                  value={bankAddress?.county ? bankAddress?.county : ""}
                  name={"county"}
                  dropdowndefaultValue={"Choose county..."}
                  options={countyArray}
                  style={{
                    height: "56px",
                    fontSize: "16px",
                    headTitleStyle: {
                      fontWeight: "600",
                      fontSize: "16px",
                      color: "#0f0f0f",
                      marginBottom: "10px",
                      fontFamily: "OpenSans, Arial, sans-serif",
                    },
                  }}
                  // borderGroup:
                  //   !lastName && lastNameReq ? "1px solid #fa4a4a" : null,
                  // backgroundColor: !lastName && lastNameReq ? "#fff1f1" : null,
                  onSelect={(e) => this.onSelect(e.value, "county")}
                />
              </Col>
              <Col
                lg={6}
                md={6}
                sm={12}
                xs={12}
                style={{ paddingRight: "0px" }}
                className="Account-detail"
              >
                <InputField
                  type="text"
                  onChange={(e) => {
                    bankAddress = bankAddress ? bankAddress : {};
                    this.getPostCode(e.target.value);
                    bankAddress.postCode = e.target.value;
                    this.setState({
                      bankAddress,
                    });
                  }}
                  value={bankAddress?.postCode ? bankAddress?.postCode : ""}
                  placeholder="PostCode"
                  style={{
                    height: "56px",
                    fontSize: "16px",
                    color: "#0f0f0f",
                    headTitle: {
                      fontWeight: "600",
                      fontSize: "18px",
                      color: "#0f0f0f",
                      marginBottom: "10px",
                      fontFamily: "OpenSans, Arial, sans-serif",
                    },
                    // borderGroup:
                    //   !lastName && lastNameReq ? "1px solid #fa4a4a" : null,
                    // backgroundColor: !lastName && lastNameReq ? "#fff1f1" : null,
                  }}
                />
                <div
                  style={{
                    display:
                      postcodeLoader || searchmode || postCodeArray?.length
                        ? "flex"
                        : "none",

                    paddingTop:
                      !postcodeLoader && searchmode && postCodeArray?.length
                        ? ""
                        : "20px",
                    textAlign:
                      !postcodeLoader && searchmode && postCodeArray?.length
                        ? ""
                        : "center",
                  }}
                  className={
                    postcodeLoader || searchmode || postCodeArray?.length
                      ? "postcode-list-div"
                      : ""
                  }
                >
                  {!postcodeLoader ? (
                    searchmode && postCodeArray?.length ? (
                      postCodeArray.map((post, index) => (
                        <p
                          key={index}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            bankAddress.postCode = post;
                            this.setState({
                              bankAddress,
                              postCodeArray: [],
                              postcodeLoader: false,
                              searchmode: false,
                            });
                          }}
                        >
                          <div className="flex-start-center post-value">
                            <Image
                              style={{
                                width: "15px",
                                marginRight: "5px",
                                marginBottom: "2px",
                              }}
                              src={require("./../../assets/icons/gps.png")}
                            />
                            <span>{post}</span>
                          </div>
                        </p>
                      ))
                    ) : (
                      "no post code"
                    )
                  ) : (
                    <div className="flex-center-center">
                      <Spinner
                        animation="border"
                        style={{ width: "25px", height: "25px" }}
                      />
                    </div>
                  )}
                </div>
              </Col>
            </Row>
            <InputField
              InputHeadTitle="Country"
              value={"United Kingdom"}
              disabled={true}
              image={require("./../../assets/icons/lock.png")}
              style={{
                height: "56px",
                fontSize: "16px",
                color: "#0f0f0f",
                headTitle: {
                  fontWeight: "600",
                  fontSize: "18px",
                  color: "#0f0f0f",
                  marginBottom: "10px",
                  fontFamily: "OpenSans, Arial, sans-serif",
                },
                // borderGroup:
                //   !lastName && lastNameReq ? "1px solid #fa4a4a" : null,
                // backgroundColor: !lastName && lastNameReq ? "#fff1f1" : null,
              }}
            />
            <div style={{ marginBottom: "40px" }} />

            <Button
              style={{
                width: "104px",
                height: "56px",
                borderRadius: "5px",
                backgroundColor: "#2cb46d",
                fontSize: "16px",
                fontWeight: "600",
              }}
              className="green-Button"
              onClick={this.updatePaymentDetail}
            >
              Update
            </Button>
            <div style={{ marginBottom: "40px" }} />
            <hr />
            <div style={{ marginBottom: "30px" }} />

            <div
              style={{
                fontWeight: "600",
                fontSize: "24px",
                color: "#0f0f0f",
                marginBottom: "10px",
                fontFamily: "OpenSans, Arial, sans-serif",
              }}
            >
              Student and parent contributions
            </div>
            <p className="common-para">
              To show appreciation for quality tutoring, parents and tutor can
              send optional financial contribution to tutors during lessons or
              after completing lessons. Tutors can opt to automatically allow or
              decline future contributions.
            </p>
            <div
              className={`${swithToogle ? "onStyle" : ""} flex-between-center`}
            >
              <div className="common-para" style={{ fontSize: "24px" }}>
                Allow contribution
              </div>
              <label class="switch switch-custom swich-label">
                <input
                  type="checkbox"
                  onChange={(e) => this.setState({ swithToogle: !swithToogle })}
                />
                <span class="slider"></span>
              </label>
            </div>
            <div style={{ marginTop: "30px" }} />
            <p className="common-para">
              100% of all contribution will be deposited into your payout
              account, unless you have an account balance. Your payout is
              subject to the{" "}
              <span
                className="green-txt"
                style={{ fontSize: "16px" }}
                onClick={() =>
                  this.props.history.push("/tutor-setting/payment-details/payment-terms-of-service")
                }
              >
                Payment Terms of Service
              </span>
              . Please note that your contribution may not be tax-deduction or
              eligible for tax credits. To learn more about guest
              contribution,visit the{" "}
              <span
                className="green-txt"
                style={{ fontSize: "16px" }}
                onClick={() =>
                  this.props.history.push("/tutor-setting/payment-details/help-center")
                }
              >
                Help center
              </span>
            </p>
            <hr />
            <div style={{ marginBottom: "80px" }} />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    TutorSettingReducer: { tutorSettingData },
  } = state;

  return {
    tutorSettingData,
  };
};
const mapDispatchToprops = (dispatch) => {
  return {
    TutorSettingStoreData: (payload) =>
      dispatch(TutorSettingAction.TutorSettingStoreData(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToprops)(PaymentDetail);
